// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  background: #c84837;
  border-color: #c84837;
  border-radius: 15%;
  color: white;
  padding: 10px;
  margin: 3px;
}

button:enabled:hover {
  background: #aa3d2f;
  border-color: #a03a2c;
  border-radius: 15%;
  color: white;
  padding: 10px;
  margin: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/core/controls/button-cancel/button-cancel.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,qBAAA;EACM,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;AACR;;AACC;EACC,mBAAA;EACA,qBAAA;EACM,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;AAER","sourcesContent":["button {\r\n\t\tbackground: #c84837;\r\n\t\tborder-color: #c84837;\r\n        border-radius: 15%;\r\n        color: white;\r\n        padding: 10px;\r\n        margin: 3px;\r\n\t}\r\n\tbutton:enabled:hover {\r\n\t\tbackground: #aa3d2f;\r\n\t\tborder-color: #a03a2c;\r\n        border-radius: 15%;\r\n        color: white;\r\n        padding: 10px;\r\n        margin: 3px;\r\n\t}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
